import type { useIntl } from "react-intl";

const CLEARANCE_LABEL_IDS: Record<string, Record<string, { id: string; defaultMessage: string }>> = {
  export: {
    no: { id: "new-request.service.noExportClearance", defaultMessage: "No, do not include Export clearance." },
    yes_provider: { id: "new-request.service.yesExportClearance", defaultMessage: "Yes, please provide Export clearance." },
    yes_internal: { id: "new-request.service.yesExportClearanceInternally", defaultMessage: "Yes, but it will be arranged internally." },
    yes_other: { id: "new-request.service.other", defaultMessage: "Other" },
  },
  import: {
    no: { id: "new-request.service.noImportClearance", defaultMessage: "No, do not include Import clearance." },
    yes_provider: { id: "new-request.service.yesImportClearance", defaultMessage: "Yes, please provide Import clearance." },
    yes_internal: { id: "new-request.service.yesImportClearanceInternally", defaultMessage: "Yes, but it will be arrange internally." },
    yes_other: { id: "new-request.service.other", defaultMessage: "Other" },
  },
  transit: {
    no: { id: "new-request.service.noTransitClearance", defaultMessage: "No, do not include Transit clearance." },
    yes_provider: { id: "new-request.service.yesTransitClearance", defaultMessage: "Yes, please provide Transit clearance." },
    yes_internal: { id: "new-request.service.yesTransitClearanceInternally", defaultMessage: "Yes, but it will be arranged internally." },
    yes_other: { id: "new-request.service.other", defaultMessage: "Other" },
  },
};

export function ReviewClearanceField({
  label,
  type,
  value,
  instructions,
  intl,
}: {
  label: string;
  type: "export" | "import" | "transit";
  value?: string;
  instructions?: string;
  intl: ReturnType<typeof useIntl>;
}) {
  if (!value) return null;

  const labelDescriptor = CLEARANCE_LABEL_IDS[type]?.[value];
  const resolvedLabel = labelDescriptor ? intl.formatMessage(labelDescriptor) : value;
  const showInstructions = value !== "no" && instructions;

  return (
    <div className="rfv2-review__service_field">
      <span className="rfv2-review__field-label">{label}</span>
      <span className="rfv2-review__gray-badge">{resolvedLabel}</span>
      {showInstructions && <span className="rfv2-review__field-value">{instructions}</span>}
    </div>
  );
}

export function ReviewClearanceFields({
  service,
  intl,
}: {
  service?: {
    export_clearance?: string;
    export_clearance_instructions?: string;
    import_clearance?: string;
    import_clearance_instructions?: string;
    transit_clearance?: string;
    transit_clearance_instructions?: string;
  };
  intl: ReturnType<typeof useIntl>;
}) {
  return (
    <>
      <ReviewClearanceField
        label={intl.formatMessage({
          id: "new-request.service.exportClearanceNeeded",
          defaultMessage: "Export clearance",
        })}
        type="export"
        value={service?.export_clearance}
        instructions={service?.export_clearance_instructions}
        intl={intl}
      />
      <ReviewClearanceField
        label={intl.formatMessage({
          id: "new-request.service.transitClearanceNeeded",
          defaultMessage: "Transit clearance",
        })}
        type="transit"
        value={service?.transit_clearance}
        instructions={service?.transit_clearance_instructions}
        intl={intl}
      />
      <ReviewClearanceField
        label={intl.formatMessage({
          id: "new-request.service.importClearanceNeeded",
          defaultMessage: "Import clearance",
        })}
        type="import"
        value={service?.import_clearance}
        instructions={service?.import_clearance_instructions}
        intl={intl}
      />
    </>
  );
}
